module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/rental-662980ded1bac67d30c82767ba7e461e.jpg";